/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelYesNo = new Class({
    Extends:QuriobotElement,
    template: function(){
        var base =  '<div class="panel--wrapper panel--yesno holds--data isLoading" family="{{ key }}" id="{{ eid }}">'+
                    '    <div class="panel--main">'+
                    '        <div class="panel--content">'+
                    '            {% button %}'+
                    '            {% options %}'+
                    '            <div class="clear"></div>'+
                    '        </div>'+
                    '        <div class="panel--overlay">'+
                    '            <div class="icon--checkWrapper circle">'+
                    '                <div class="check"></div>'+
                    '            </div>'+
                    '            <button type="button" aria-label="' + this.data.i18n.redo.button.title + '" aria-hidden="true" class="icon--redoWrapper">'+
                    '                <div class="redo"></div>'+
                    '            </button>'+
                    '        </div>'+
                    '    </div>'+
                    '</div>';

        var option =  '<div class="yesno--option option--{{ type }}" data-option-value="{{ type }}">'+
                      '      <button type="button" class="option--content">'+
                      '          <div class="option--text" aria-label="{{ text }}">{{ text }}</div>'+
                      '          <div class="icon--checkWrapper dark atLeft">'+
                      '             <div class="check"></div>'+
                      '          </div>'+
                      '      </button>'+
                      '</div>';

        var button =
          '<div class="large-button__wrapper">' +
          '  <button type="button" class="large--button open-popup" aria-label="{% go_button_text %}" data-url="{% url %}">' +
          '      <div class="button--text">{% go_button_text %}</div>' +
          '  </button>' +
          '</div>'

        return {'base': base, 'option': option, 'button': button};
    },
    attach: function(){
        var notRequired = this.data.is_required === false;
        var Options = this.element.getElements('.yesno--option');
            Options.each(function(oOption,i){

                if (this.data.meta.displayType === "window") {
                    oOption.setStyle('display','none')
                }

                oOption.addEvents({
                    click: function(){
                        Options.removeClass('selected--option');
                        Options.set('aria-checked', false);
                        oOption.addClass('selected--option');
                        oOption.set('aria-checked', true);
                        this.after(oOption.get('data-option-value'), oOption.getElements('.option--text')[0].get('text'));
                    }.bind(this)
                });
            }.bind(this));


        if (this.data.meta.displayType === "window") {
            var button = this.element.getElements('.open-popup')[0];
            var url = button.get('data-url');
            this.quriobot.populateURL(url, function(url){
                // Add panel--button className
                this.element.addClass('panel--button');
                button.addEvents({
                    click: function(){
                        var title = this.data.meta.title || "qbDisplayURL";
                        var popup = this.popupWindow(url, title, 800, 600);
                        var timer = setInterval(function() {
                            if(popup.closed) {
                                clearInterval(timer);
                                if (notRequired) {
                                    this.after(null, '')
                                }
                            }
                        }.bind(this), 1000);
                        button.setStyle('display', 'none');

                        // Remove panel--button className when button has been clicked
                        this.element.removeClass('panel--button');

                        if (notRequired) {
                            this.element.hide();
                        }

                        Options.each(function(oOption){
                            oOption.setStyle('display', 'inline-block')
                        })
                    }.bind(this)
                })
            }.bind(this))
        } else if (notRequired) {
            this.element.hide();
        }
    },
    popupWindow: function (url, title, w, h) {
        var y = window.outerHeight / 2 + window.screenY - ( h / 2),
            x = window.outerWidth / 2 + window.screenX - ( w / 2);
        return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+y+', left='+x);
    },
    addToDom: function(newElement){
        var notRequired = this.data.is_required === false;
        if(newElement){
            $('botSpinner').addClass('bot--spinner__loading');
            if(this.data.type.name == 'yesno_display'){
                this.populateAnswer(function(value) {
                    this.quriobot.populateValues(this.data.meta.title, function(title){
                        var meta = Object.assign({}, this.data.meta, {title: title});
                        this.foldOut(value, meta, function() {
                            if (notRequired) {
                                this.after(this.data.options[0].type, this.data.options[0].text, true)
                            }
                        }.bind(this));
                    }.bind(this))
                }.bind(this), this.data.meta && this.data.meta.displayType === "html" ?
                    this.data.display_html :
                    this.data.meta && (
                        this.data.meta.displayType === "iframe" || this.data.meta.displayType === "window") ?
                    this.data.url :
                    (this.data.display_html || this.data.url))
            }
            this.parent_after.appendHTML(newElement, 'before');
            this.in();
            return;
        }
        $('botSpinner').removeClass('bot--spinner__loading');
        this.populate()
    },
    after: function(answer, text, skipClose){
        this.element.addClass('isAnswered');
        this.answerCallback(this.data, {
            answer:{
                'value': answer,
                'content': text,
                'render': false
            }
        });
        if (!skipClose) {
            this.foldOutClose();
            // Add `aria-hidden="true"` after answering to the question
            this.setAriaHidden('.panel--content', true);

            // Remove `aria-hidden="true"` from redo-button
            this.setAriaHidden('.icon--redoWrapper', false);
        }
    }
});
